import { gql } from '@apollo/client';

export const QUERY_RESSOURCES = gql`
  query RessourcesAllByTypes {
    challengeRessources(sort: "order:asc") {
      data {
        attributes {
          name
          subtitle
          info
          desc
          order
          ressource_type {
            data {
              id
              attributes {
                name
              }
            }
          }
        }
      }
    }
  }
`;

export const QUERY_RESSOURCES_TYPES = gql`
  query GetRessourcesTypes {
    findChallengeRessourceTypeWithRelatedChallengeRessources {
      id
      name
      challenge_ressources {
        name
      }
    }
  }
`;
